import axios from "axios";
import Cookies from "js-cookie";
import configData from "./config.json";

const api = axios.create({
  baseURL: configData.SERVER_URL, // Replace with your backend URL
});

axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';


api.interceptors.request.use(
  async (config) => {
    const token = Cookies.get("agpunchout-authorization"); // Get JWT from cookie

    if (!token) {
      return Promise.reject("No authorization token found");
    }

    config.headers.Authorization = `Bearer ${token}`;
    return config; 
  },
  (error) => {
    return Promise.reject(error);
  }
);





export default api;
